'use client';

import { useSearchParams } from 'next/navigation';
import { Link } from '@/components/link';

interface IChangelogHashTagProps {
  children: React.ReactNode;
  tag: string;
}

export const ChangelogHashTag = ({ children, tag }: IChangelogHashTagProps): React.JSX.Element => {
  const searchParams = useSearchParams();
  const currentTag = searchParams.get('tag');
  const isActive = currentTag === tag;

  return (
    <Link
      href={isActive ? '?' : `?tag=${tag}`}
      className={`px-2 py-1 text-sm rounded-full transition-colors ${
        isActive
          ? 'bg-blue-600 text-white hover:bg-blue-700'
          : 'bg-blue-50 text-blue-700 hover:bg-blue-100'
      }`}
    >
      {children}
    </Link>
  );
};
